import Swal from 'sweetalert2'

const showMessage = (message) => {
  if (message !== null && message !== '') {
    Swal({
      title: message,
      buttonsStyling: false,
      confirmButtonClass: 'btn btn-success btn-fill'
    });
  }
}

const showMissingAnswerMessage = () => {
  Swal({
    title: 'Por favor, preencha todos os campos obrigatórios marcados com "*".',
    buttonsStyling: false,
    confirmButtonClass: 'btn btn-success btn-fill'
  });
}

const showMissingAnswerMessageWithParams = (params) => {
  Swal({
    title: 'Por favor, preencha os campos: ' + params + '.',
    buttonsStyling: false,
    confirmButtonClass: 'btn btn-success btn-fill'
  });
}

export default {
  showMessage,
  showMissingAnswerMessage,
  showMissingAnswerMessageWithParams
}



// WEBPACK FOOTER //
// ./src/services/Mensagens.js